<template>
    <div>
        <config-main-title>
            Validação dos Cadastros para Atendimento
        </config-main-title>

        <div class="row">

            <div class="col col-12 col-md-8">

                <!-- Seleção da Unidade -->

                <div class="row d-flex justify-content-center mb-2">

                    <div class="col col-12">

                        <div class="input-group mb-1">
                            <div class="input-group-prepend">
                                <span class="input-group-text" id="basic-addon1">
                                    <i class="fa fa-building fa-fw" aria-hidden="true"></i>
                                </span>
                            </div>
                            <select class="form form-control" v-model="dados.unidade_operacao">
                                <option value="">Todas as Unidades</option>
                                <option v-for="(und, iux) in this.$store.state.unidade.unidade_operacaos" :value="und" :key="iux">{{ und.search }}</option>
                            </select>
                        </div>

                    </div>

                </div>

                <!-- Seleção da Operadora / Plano -->

                <div class="row d-flex justify-content-center mb-2">

                    <div class="col col-12">

                        <az-input
                            placeholder="Operadora/Plano"
                            icon="far fa-credit-card"
                            type="autocomplete" 
                            optionsMode="aql"
                            service="planos.index"
                            :optionsSync="false"
                            v-model="dados.plano"
                            ref="info_plano"
                            @onEnter="focusOn('info_procedimento')" />

                    </div>

                </div>

                <!-- Seleção do Procedimento -->

                <div class="row d-flex justify-content-center mb-2">

                    <div class="col col-12">

                        <AzInput placeholder="Procedimento"
                                icon="fas fa-play"
                                type="autocomplete" 
                                optionsMode="aql"
                                optionsName="procedimentos.index" 
                                :optionsSync="false"
                                service="procedimentos.index"
                                v-model="dados.procedimento"
                                ref="info_procedimento" />

                    </div>

                </div>

                <!-- Selecionar Médico -->

                <div class="row d-flex justify-content-center mb-3">

                    <div class="col col-12">

                        <AzInput placeholder="Profissional"
                                icon="fas fa-briefcase-medical"
                                type="autocomplete" 
                                service="medicos.index"
                                optionsDisplay="st_nome_exibicao"
                                v-model="dados.medico"
                                ref="info_medico" />

                    </div>

                </div>
                    
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading"></div>
            <div class="determinate" v-else></div>
        </div>

        <div>

            <!-- Rateio -->

            <div class="alert alert-success" v-if="rateio && rateio.rateio">
                <div>
                    <a href="#" @click.prevent="editar_rateio(rateio.rateio)" class="alert-link">
                        <strong>Rateio: #{{ rateio.rateio.id_rateio_medico }}</strong>
                    </a>
                </div>
                <div class="d-flex justify-content-between">
                    <div>{{ rateio.rateio.st_titulo }}</div>
                    <div>{{ rateio.rateio.info_rateio }}</div>
                </div>
                <pre v-if="false">{{ rateio }}</pre>
            </div>

            <!-- Operadora vs Unidade -->

            <div class="mt-3" v-if="lista_unidade_operadora">
                <div v-if="dados.unidade_operacao">
                    <template v-if="dados.unidade_operacao.dt_limite_agenda_aberta">
                        <p class="alert" :class="dados.unidade_operacao.dt_limite_agenda_aberta < $util.hoje() ? 'alert-danger' : 'alert-success'">
                            Agendas abertas até: {{ $util.getFormatDate(dados.unidade_operacao.dt_limite_agenda_aberta) }}
                        </p>
                    </template>

                    <ul class="list-group mb-3" v-if="unidade_particulares && unidade_particulares.length">
                        <li class="list-group-item list-group-item-primary">
                            <div class="d-flex justify-content-between">
                                <span>
                                    Particular x Unidade 
                                </span>
                            </div>
                        </li>
                        <li class="list-group-item" v-for="(item, im) in unidade_particulares" :key="im">
                            <i class="fas fa-check text-success mr-2" v-if="item.unidade_operacao_plano && item.unidade_operacao_plano.fl_ativo == 1"></i>
                            <i class="fas fa-ban text-danger mr-2" v-if="item.unidade_operacao_plano && item.unidade_operacao_plano.fl_ativo == 0"></i>
                            <span v-if="item.search">
                                {{ item.search }}
                            </span>
                        </li>
                    </ul>

                    <ul class="list-group">
                        <li class="list-group-item list-group-item-primary">
                            <div class="d-flex justify-content-between">
                                <span>
                                    Operadora x Unidade 
                                </span>
                            </div>
                        </li>
                        <li class="list-group-item" v-for="(item, im) in lista_unidade_operadora" :key="im">
                            <i class="fas fa-check text-success mr-2" v-if="item.unidade_operadora && item.unidade_operadora.fl_ativo == 1"></i>
                            <i class="fas fa-ban text-danger mr-2" v-if="item.unidade_operadora && item.unidade_operadora.fl_ativo == 0"></i>
                            <span v-if="item.search">
                                {{ item.search }}
                            </span>
                        </li>
                    </ul>
                </div>
                <div v-else-if="lista_unidade_operadora && lista_unidade_operadora.length">
                    <ul class="list-group">
                        <li class="list-group-item list-group-item-primary">
                            <div class="d-flex justify-content-between">
                                <span>
                                    Operadora x Unidade 
                                </span>
                            </div>
                        </li>
                        <li class="list-group-item" v-for="(item, im) in lista_unidade_operadora" :key="im">
                            <i class="fas fa-ban text-danger mr-2"></i>
                            <span v-if="item.unidade_operacao">
                                {{ item.unidade_operacao.search }}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Operadora / Plano -->

            <div class="mt-3">

                <ul class="list-group" v-if="medico_operadoras">
                    <li class="list-group-item list-group-item-primary">
                        <div class="d-flex justify-content-between">
                            <span>
                                Operadora x Profissonal 
                            </span>
                            <a href="#" class="card-link" @click.prevent="goto ('c-operadoras', { id_operadora: dados.plano.id_operadora })">
                                <i class="fas fa-pen"></i>
                            </a>
                        </div>
                    </li>

                    <li class="list-group-item" v-if="dados.medico && medico_operadoras && !medico_operadoras.length">
                        <i class="fas fa-ban text-danger mr-2" v-if="dados.plano.id_operadora != 1"></i>
                        {{ dados.medico.search }}
                    </li>

                    <li class="list-group-item" v-for="(md, im) in medico_operadoras" :key="im">
                        <i class="fas fa-check text-success mr-2"></i>
                        {{ md.search }}
                    </li>
                </ul>

            </div>
                  
            <!-- Procedimento -->
            <div class="card mt-3" v-if="dados.procedimento">
                <div class="card-header alert-primary d-flex justify-content-between">
                    <div>
                        {{ dados.procedimento.search }}
                    </div>
                    <div>
                        #{{ dados.procedimento.id_procedimento }}
                    </div>
                </div>
                <div class="card-body">
                    <div v-if="dados.procedimento.in_paciente_idade_minima">
                        Idade Mínima: {{ dados.procedimento.in_paciente_idade_minima }} ano(s)
                    </div>
                    <div v-if="dados.procedimento.in_paciente_idade_maxima || dados.procedimento.in_paciente_idade_maxima === 0">
                        Idade Máxima: {{ dados.procedimento.in_paciente_idade_maxima }} ano(s)
                    </div>
                    <div v-if="dados.procedimento.ch_paciente_sexo">
                        Apenas Sexo: {{ dados.medico.medico_unidade.ch_paciente_sexo }}
                    </div>
                </div>
            </div>

            <div class="mt-3">

                <ul class="list-group" v-if="medico_procedimentos">
                    <li class="list-group-item list-group-item-primary">
                        <div class="d-flex justify-content-between">
                            <span>
                                Procedimento x Profissonal 
                            </span>
                            <a href="#" class="card-link" @click.prevent="goto('c-procedimentos', { id_procedimento: dados.procedimento.id_procedimento })">
                                <i class="fas fa-pen"></i>
                            </a>
                        </div>
                    </li>

                    <li class="list-group-item" v-if="dados.medico && medico_procedimentos && !medico_procedimentos.length">
                        <i class="fas fa-ban text-danger mr-2"></i>
                        {{ dados.medico.search }}
                        <div v-if="dados.medico && dados.medico.medico_unidade && dados.medico.medico_unidade.in_paciente_idade_minima">
                            <i class="fa fa-exclamation-triangle text-warning mr-2" aria-hidden="true"></i>
                            Idade Mínima: {{ dados.medico.medico_unidade.in_paciente_idade_minima }}
                        </div>
                        <div v-if="dados.medico && dados.medico.medico_unidade && ( dados.medico.medico_unidade.in_paciente_idade_maxima || dados.medico.medico_unidade.in_paciente_idade_maxima === 0 )">
                            <i class="fa fa-exclamation-triangle text-warning mr-2" aria-hidden="true"></i>
                            Idade Máxima: {{ dados.medico.medico_unidade.in_paciente_idade_maxima }}
                        </div>
                        <div v-if="dados.medico && dados.medico.medico_unidade && dados.medico.medico_unidade.ch_paciente_sexo">
                            <i class="fa fa-exclamation-triangle text-warning mr-2" aria-hidden="true"></i>
                            Sexo: {{ dados.medico.medico_unidade.ch_paciente_sexo }}
                        </div>

                        <ul class="list-group mt-3">
                            <li class="list-group-item" v-for="(espec, iex) in dados.medico.medico_especialidade" :key="iex">
                                {{ espec.especialidade.search }}
                                <div v-if="espec.in_paciente_idade_minima">
                                    <i class="fa fa-exclamation-triangle text-warning mr-2" aria-hidden="true"></i>
                                    Idade Mínima: {{ espec.in_paciente_idade_minima }}
                                </div>
                                <div v-if="espec.in_paciente_idade_maxima || espec.in_paciente_idade_maxima === 0">
                                    <i class="fa fa-exclamation-triangle text-warning mr-2" aria-hidden="true"></i>
                                    Idade Máxima: {{ espec.in_paciente_idade_maxima }}
                                </div>
                                <div v-if="espec.ch_paciente_sexo">
                                    <i class="fa fa-exclamation-triangle text-warning mr-2" aria-hidden="true"></i>
                                    Sexo: {{ espec.ch_paciente_sexo }}
                                </div>
                            </li>
                        </ul>
                    </li>

                    <li class="list-group-item" v-for="(md, im) in medico_procedimentos" :key="im">
                        <i class="fas fa-check text-success mr-2"></i>
                        {{ md.medico_unidade.medico.search }}
                    </li>
                </ul>
                
            </div>

            <!-- Vinculo Procedimento vs Operadora -->

            <ul class="list-group mt-3" v-if="tabela_operadoras">
                <li class="list-group-item list-group-item-primary">
                    <div class="d-flex justify-content-between">
                        <span>
                            Procedimento x Operadora 
                        </span>
                        <a href="#" class="card-link" @click.prevent="goto('c-procedimentos', { id_procedimento: dados.procedimento.id_procedimento })">
                            <i class="fas fa-pen"></i>
                        </a>
                    </div>
                </li>

                <template v-if="tabela_operadoras.length">
                    <li class="list-group-item" v-for="(tabela, itx) in tabela_operadoras" :key="itx">
                        <i class="fas fa-check text-success mr-2"></i>
                        Tabela: {{ tabela.search }} 
                        <i class="fas fa-caret-right mx-3"></i>
                        {{ tabela.tabela_versao.search }}                       
                        <span class="badge badge-secondary ml-1">
                            #{{ tabela.id_tabela_versao }}
                        </span>
                    </li>
                </template>
                <template v-else>
                    <li class="list-group-item">
                        <i class="fas fa-ban text-danger mr-2"></i>
                        Não presente em tabela de preço.
                    </li>
                </template>
            </ul>

            <div class="card mt-3" v-if="dados.medico">
                <div class="card-header alert-primary d-flex justify-content-between">
                    <div>
                        {{ dados.medico.search }}
                    </div>
                    <div>
                        <span v-if="dados.medico.conselho">
                            {{ dados.medico.conselho.st_sigla }}
                        </span>
                        <span v-if="dados.medico.in_numero_conselho">
                            {{ dados.medico.in_numero_conselho }}
                            <span v-if="dados.medico.estado_conselho">
                                {{ dados.medico.estado_conselho.st_sigla }}
                            </span>
                        </span>
                    </div>
                </div>
                <div class="card-body">
                    <div v-if="dados.medico.medico_unidade">
                        <div v-if="dados.medico.medico_unidade.in_paciente_idade_minima">
                            Idade Mínima: {{ dados.medico.medico_unidade.in_paciente_idade_minima }} ano(s)
                        </div>
                        <div v-if="dados.medico.medico_unidade.in_paciente_idade_maxima || dados.medico.medico_unidade.in_paciente_idade_maxima === 0">
                            Idade Máxima: {{ dados.medico.medico_unidade.in_paciente_idade_maxima }} ano(s)
                        </div>
                        <div v-if="dados.medico.medico_unidade.ch_paciente_sexo">
                            Apenas Sexo: {{ dados.medico.medico_unidade.ch_paciente_sexo }}
                        </div>
                    </div>

                    <hr>

                    <div>Especialidades:</div>
                    <ul class="mb-0">
                        <li v-for="(espec, iex) in dados.medico.medico_especialidade" :key="iex">
                            {{ espec.especialidade.search }}
                            <div v-if="espec.in_paciente_idade_minima" class="small">
                                Idade Mínima: {{ espec.in_paciente_idade_minima }} ano(s)
                            </div>
                            <div v-if="espec.in_paciente_idade_maxima || espec.in_paciente_idade_maxima === 0" class="small">
                                Idade Máxima: {{ espec.in_paciente_idade_maxima }} ano(s)
                            </div>
                            <div v-if="espec.ch_paciente_sexo" class="small">
                                Apenas Sexo: {{ espec.ch_paciente_sexo }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- Unidade --> 

            <ul class="list-group mt-3" v-if="unidade_operacao">
                <li class="list-group-item list-group-item-primary">
                    <div class="d-flex justify-content-between">
                        <span>
                            {{ unidade_operacao.st_nome }}
                            <span class="badge badge-secondary">#{{ unidade_operacao.id_unidade_operacao }}</span>
                        </span>
                        <span v-if="unidade_operacao.st_sigla">
                            <span class="badge badge-light">{{ unidade_operacao.st_sigla }}</span>
                        </span>
                    </div>
                </li>

                <template v-if="unidade_operacao.procedimento_lista && unidade_operacao.procedimento_lista.length">
                    <li class="list-group-item" v-for="(proced, ipx) in unidade_operacao.procedimento_lista" :key="ipx">
                        <i class="fa fa-ban text-danger mr-2" aria-hidden="true"></i>
                        {{ proced.procedimento.search }}
                    </li>
                </template>
            </ul>

            <!-- Agendas -->

            <div class="alert alert-warning mt-3" v-if="dados.procedimento && dados.procedimento.id_classe_procedimento == 1">
                <b>Prazo de Revisão:</b><br>
                <ul class="mb-0">
                    <li v-if="dados.medico && dados.medico.medico_unidade">
                        Profissional {{ dados.medico.st_nome_exibicao }}: 
                        {{ dados.medico.medico_unidade.in_prazo_revisao}} dias
                    </li>
                    <li v-if="dados.plano && dados.plano.operadora">
                        Operadora {{ dados.plano.operadora.search }}: 
                        {{ dados.plano.operadora.in_prazo_revisao }} dias
                    </li>
                </ul>
            </div>
    
            <!-- Agendas -->

            <div class="mt-3">

                <ul class="list-group" v-if="agenda_procedimentos">
                    <li class="list-group-item list-group-item-primary">
                        <div class="d-flex justify-content-between">
                            <span>
                                Agendas
                            </span>
                            <a href="#" class="card-link" @click.prevent="goto('c-agendas', { id_medico: dados.medico.id_pessoa })">
                                <i class="fas fa-pen"></i>
                            </a>
                        </div>
                    </li>

                    <li class="list-group-item" v-if="dados.medico && agenda_procedimentos && !agenda_procedimentos.length">
                        <i class="fas fa-ban text-danger mr-2"></i>
                        {{ dados.medico.search }}
                    </li>

                    <li class="list-group-item" v-for="(agp, im) in agenda_procedimentos" :key="im" :class="agp.agenda.agenda_grupo.dt_vigencia_termino < $util.hoje() ? 'list-group-item-secondary' : ''">
                        <i class="fas fa-check text-success mr-2"></i>
                        {{ agp.agenda.medico.search }} <i class="fas fa-caret-right mx-2"></i>
                        {{ agp.agenda.agenda_grupo.search }} 
                        <span class="badge badge-dark ml-2">{{ traduzir_dia_semana(agp.agenda.in_dia_semana) }}</span>

                        <span v-if="agp.agenda.agenda_grupo.dt_vigencia_termino < $util.hoje()" class="badge badge-secondary ml-2">Passado</span>
                        <span v-if="agp.agenda.agenda_grupo.dt_vigencia_inicio > $util.hoje()" class="badge badge-secondary ml-2">Futuro</span>
                        
                        <span class="badge badge-secondary ml-2">#{{ agp.agenda.id_agenda }}</span>
                        <span v-if="agp.agenda.local">
                            <i class="fas fa-caret-right mx-2"></i>
                            {{ agp.agenda.local.centro_custo.unidade_operacao.search }}
                        </span>

                        <span v-if="agp.fl_agenda_online" class="badge badge-dark ml-3">
                            Agenda Online
                        </span>

                        <span v-if="agp.agenda.agenda_grupo.dt_abertura && agp.agenda.agenda_grupo.dt_abertura > $util.hoje()" class="badge badge-danger ml-3">
                            Abertura em: {{ $util.getFormatDate(agp.agenda.agenda_grupo.dt_abertura) }}
                        </span>

                        <div class="alert alert-secondary py-1 mb-0 small mt-1" v-if="agp.agenda.agenda_grupo.fl_listar_datas">
                            Datas: {{ agp.agenda.agenda_grupo.proximas_datas ? agp.agenda.agenda_grupo.proximas_datas.map(dt => $util.getFormatDate(dt.dt_data)).join(', ') : '' }}
                        </div>
                    </li>
                </ul>

                <div v-if="lista_unidades && lista_unidades.length">
                    <ul class="list-group mt-3">
                        <li class="list-group-item list-group-item-primary">
                            <div class="d-flex justify-content-between">
                                <span>
                                    Unidades
                                </span>
                                <div>
                                    <span class="badge badge-secondary">
                                        {{ lista_unidades.length }}
                                    </span>
                                </div>
                            </div>
                        </li>

                        <li class="list-group-item" v-for="(unidade, iux) in lista_unidades" :key="iux">
                            {{ unidade.st_nome }}
                            <span class="badge badge-secondary ml-2">#{{ unidade.id_unidade_operacao }}</span>
                            <span v-if="unidade.st_cnes" class="badge badge-secondary ml-2">
                                CNES: {{ unidade.st_cnes }}
                            </span>
                        </li>
                    </ul>
                </div>

                <div class="alert alert-info mt-3" v-if="api_agenda_online">
                    API apenas agenda definida como <strong>AGENDA ON-LINE</strong>.
                </div>
                
            </div>

            <!-- Instruções -->

            <az-instrucoes class="mt-3" :dados="dados" />

            <pre v-if="false">{{ dados }}</pre>
            
        </div>

        <hr>

        <edicao-rateio-medico ref="editarrateio" @refresh="validacao()" />

    </div>
</template>

<script>
import _ from 'lodash';
import AzInput from '../../shared/forms/AzInput.vue';
import ConfigMainTitle from '../shared/ConfigMainTitle.vue';
import AzInstrucoes from '../../util/AzInstrucoes.vue';
import EdicaoRateioMedico from '../shared/EdicaoRateioMedico.vue';

export default {
    data () { 
        return { 
            dados: { unidade_operacao: "" }, 
            valid_plano: null, 
            medico_operadoras: null, 
            medico_procedimentos: null, 
            agenda_procedimentos: null, 
            lista_unidade_operadora: null, 
            tabela_operadoras: null,
            unidade_operacao: null, 
            rateio: null, 
            api_agenda_online: false, 
            unidade_particulares: null, 
        }
    },

    watch: { 
        dados: { 
            handler () { 
                this.validacao ();
            },
            deep: true, 
            immediate: true, 
        }
    },

    components: { 
        AzInput,
        ConfigMainTitle,
        AzInstrucoes,
        EdicaoRateioMedico, 
    },

    computed: { 
        lista_unidades: function () { 
            if ( !this.agenda_procedimentos )
                return [];

            return _.orderBy(
                _.uniqBy(
                    this.agenda_procedimentos.map(agp => agp.agenda.local.centro_custo.unidade_operacao),
                    'id_unidade_operacao'
                ),
                'st_nome'
            );
        }
    },

    methods: { 
        traduzir_dia_semana (dia) { 
            switch (dia) {
                case 0: return 'Dom';
                case 1: return 'Seg';
                case 2: return 'Ter';
                case 3: return 'Qua';
                case 4: return 'Qui';
                case 5: return 'Sex';
                case 6: return 'Sab';
                default: return dia;                    
            }
        },

        editar_rateio (item) { 
            this.$refs.editarrateio.editar(item.id_rateio_medico);
        },

        goto (rota, parm) { 
            this.$router.push({ name: rota, params: { ...parm }});
        },

        validacao () { 

            this.medico_operadoras = null; 
            this.medico_procedimentos = null; 
            this.tabela_operadoras = null;
            this.unidade_particulares = null; 

            let query = { q: [] };
            let add_filtro = {};
            let add_parm = {};

            if ( this.dados.unidade_operacao ) { 

                let add_filtro = this.dados.plano ? { id_operadora: this.dados.plano.id_operadora } : {};

                this.$util.load(this, { 
                    service: 'operadoras',
                    func: 'index',
                    parms: { 
                        cadastro_unidade: true, 
                        id_unidade_operacao: this.dados.unidade_operacao.id_unidade_operacao,
                        where: { 
                            ...add_filtro,
                        },
                    },
                    loadTo: res => { 
                        this.lista_unidade_operadora = res;
                    }
                });

                query.q.push({ 
                    name: 'unidade_operacaos.show',
                    id: 'unidade_operacao',
                    parms: {
                        with: [
                            'procedimento_lista.procedimento.especialidade:id_especialidade,st_especialidade',
                        ],
                        id: this.dados.unidade_operacao.id_unidade_operacao,
                    }
                });

                query.q.push({ 
                    name: 'planos.index',
                    id: 'unidade_particulares',
                    parms: {
                        cadastro_unidade: true,
                        id_unidade_operacao: this.dados.unidade_operacao.id_unidade_operacao,
                        id_plano: this.dados.plano ? this.dados.plano.id_plano : null,
                    }
                });

            } else if ( this.dados.plano ) { 
                
                this.$util.load(this, { 
                    service: 'unidade_operadoras',
                    func: 'index',
                    parms: { 
                        where: { 
                            id_operadora: this.dados.plano.id_operadora,
                            fl_ativo: 0,
                        },
                    },
                    with: ['unidade_operacao'],
                    loadTo: res => { 
                        this.lista_unidade_operadora = res;
                    }
                });

            } else { 

                this.lista_unidade_operadora = null;

            }

            if ( this.dados.plano ) { 

                if ( this.dados.medico ) 
                    add_filtro = { id_medico: this.dados.medico.id_pessoa };
                else 
                    add_filtro = {};

                query.q.push({ 
                    name: 'medico_operadoras.index',
                    id: 'medico_operadoras',
                    parms: {
                        with: 'medico',
                        where: { 
                            id_operadora: this.dados.plano.id_operadora,
                            fl_ativo: true, 
                            ...add_filtro,
                        }
                    }
                });

                //



/*
                this.$util.load(this, {
                service: 'planos',
                func: 'index',
                parms: {
                    cadastro_unidade: true,
                    id_unidade_operacao: this.edicao_unidade.id_unidade_operacao,
                },
                loadTo: res => {
                    this.lista_unidade_operacao_planos = res;
                }
            });

            $('#unidadeOperacaoPlanosModal').modal('show');
        },

        editar_unidade_operadoras(unidade) {
            $('.modal').modal('hide');
            this.lista_unidade_operadora = [];
            this.edicao_unidade = unidade;

            this.$util.load(this, {
                service: 'operadoras',
                func: 'index',
                parms: {
                    cadastro_unidade: true,
                    id_unidade_operacao: this.edicao_unidade.id_unidade_operacao,
                },
                loadTo: res => {
                    this.lista_unidade_operadora = res;
                }
            });

            $('#unidadeOperadorasModal').modal('show'); */

                //

            }

            if ( this.dados.procedimento ) { 

                if ( this.dados.medico ) 
                    add_parm = { id_medico: this.dados.medico.id_pessoa };
                else 
                    add_parm = {};

                query.q.push({ 
                    name: 'medico_procedimento_unidades.index',
                    id: 'medico_procedimentos',
                    parms: { 
                        ...add_parm, 
                        where: { 
                            id_procedimento: this.dados.procedimento.id_procedimento,
                            fl_ativo: true, 
                        }
                    }
                });

                query.q.push({ 
                    name: 'agenda_procedimentos.index',
                    id: 'agenda_procedimentos',
                    parms: { 
                        ...add_parm, 
                        where: { 
                            id_procedimento: this.dados.procedimento.id_procedimento,
                            fl_ativo: true, 
                        }
                    }
                });

                query.q.push({ 
                    name: 'configuracoes.index',
                    id: 'api_agenda_online',
                    parms: { 
                        where: { 
                            st_slug: 'api-agenda-online',
                            fl_ativo: true, 
                        }
                    }
                });

                if ( this.dados.plano && this.dados.unidade_operacao && this.dados.medico ) { 

                    query.q.push({ 
                        name: 'rateios.simulacao',
                        id: 'rateio',
                        parms: { 
                            id_procedimento: this.dados.procedimento.id_procedimento,
                            id_plano: this.dados.plano.id_plano,
                            id_unidade_operacao: this.dados.unidade_operacao.id_unidade_operacao, 
                            id_medico: this.dados.medico.id_pessoa,
                        }
                    });

                }

                if ( this.dados.plano && this.dados.plano.id_operadora > 1 && !this.dados.plano.operadora.fl_sus ) { 

                    query.q.push({ 
                        name: 'tabela_operadoras.index',
                        id: 'tabela_operadoras',
                        parms: { 
                            id_procedimento: this.dados.procedimento.id_procedimento,
                            id_operadora: this.dados.plano.id_operadora,
                        }
                    });

                }

            }

            if ( query.q.length ) { 

                this.axios.post ('/aql?a=validacoes', query)
                    .then(res => { 
                        if ( res.data.unidade_particulares && res.data.unidade_particulares.status == 200 ) { 
                            this.unidade_particulares = res.data.unidade_particulares.data;
                        }

                        if ( res.data.medico_operadoras && res.data.medico_operadoras.status == 200 ) { 
                            this.medico_operadoras = res.data.medico_operadoras.data;
                        }

                        if ( res.data.medico_procedimentos && res.data.medico_procedimentos.status == 200 ) { 
                            this.medico_procedimentos = res.data.medico_procedimentos.data;
                        }

                        if ( res.data.agenda_procedimentos && res.data.agenda_procedimentos.status == 200 ) { 
                            this.agenda_procedimentos = res.data.agenda_procedimentos.data;
                        }

                        if ( res.data.unidade_operacao && res.data.unidade_operacao.status == 200 ) { 
                            this.unidade_operacao = res.data.unidade_operacao.data;
                        }

                        if ( res.data.tabela_operadoras && res.data.tabela_operadoras.status == 200 ) { 
                            this.tabela_operadoras = res.data.tabela_operadoras.data;
                        } else { 
                            this.tabela_operadoras = null;
                        }

                        if ( res.data.rateio && res.data.rateio.status == 200 ) { 
                            this.rateio = res.data.rateio.data;
                        } else { 
                            this.rateio = null;
                        }

                        if ( res.data.api_agenda_online && res.data.api_agenda_online.status == 200 ) { 
                            this.api_agenda_online = _.get(res.data.api_agenda_online.data, '0.st_valor') ? true : false;
                        } else { 
                            this.api_agenda_online = false;
                        }
                    });

            }

        },

        selecionarProcedimento (proc) { 
            console.log(proc);    
        },

        focusOn (ref) { 
            console.log(ref);
        }
    },

    mounted () { 

        this.breadcrumb = [
                { name: "Configurações", path: "/cadastros"},
                { name: "Validação de Cadastros", path: "/cadastros" },
            ];

        this.$store.commit('setBreadcrumb', this.breadcrumb);

        this.$util.valid_permissao(this, 99);
    }
}
</script>